import { Field, Int, ObjectType } from '@nestjs/graphql'
import { BasicUserDto } from './basicModel.dto'
import { BaseModelWithoutUserDto } from '../base/baseModelWithoutUser.dto'
import { ArcClaimDto } from '../arc'

@ObjectType()
export class ReportedUserModelDto extends BaseModelWithoutUserDto {
  @Field(type => Int)
  type!: number

  @Field(type => Int)
  reportedDocumentId!: number

  @Field({ nullable: true })
  reasonType?: number

  @Field({ nullable: true })
  extendedReason?: string

  @Field(type => BasicUserDto)
  reportedByUser!: BasicUserDto

  @Field({ nullable: true })
  ignored?: boolean

  @Field()
  date!: Date

  @Field(t => ArcClaimDto, { nullable: true })
  claim?: ArcClaimDto
}
